
require('formdata-polyfill');
require('isomorphic-fetch');

// This is what the module will return. We define some of the functiosn in this namespace
// to be able to test them easely
var expose = {};

var mdModules = {
    'column': require("../column/column"),
    'personalinfo': require("../personalinfo/personalinfo"),
    'consent': require("../consent/consent"),
    'consentemail': require("../consentemail/consentemail"),
    'consentphone': require("../consentphone/consentphone"),
    'subscribe': require("../subscribe/subscribe"),
    'contacttime': require("../contacttime/contacttime"),
    'currentbrandselect': require("../currentbrandselect/currentbrandselect"),
    'brochures': require("../brochures/brochures"),
    'iscompany': require("../iscompany/iscompany"),
    'retailers': require("../retailers/retailers"),
    'retailersmodal': require("../retailersmodal/retailersmodal"),
    'models': require("../models/models"),
    'checkbox': require("../checkbox/checkbox"),
    'dropdown': require("../dropdown/dropdown"),
    'consentpost': require("../consentpost/consentpost"),
    'radiobutton': require("../radiobutton/radiobutton"),
    'input': require("../input/input"),
    'firstname': require("../firstname/firstname"),
    'lastname': require("../lastname/lastname"),
    'email': require("../email/email"),
    'zipcode': require("../zipcode/zipcode"),
    'pagebreak': require("../pagebreak/pagebreak"),
    //'image': require("../image/image"),
    'submit': require("../submit/submit"),
    'district': require("../district/district"),
    'regnr': require("../regnr/regnr"),
    'commisionnumber': require("../commisionnumber/commisionnumber"),
    'address': require("../address/address"),
    'co': require("../co/co"),
    'company': require("../company/company"),
    'phone': require("../phone/phone"),
    'message': require("../message/message"),
    'mobile': require("../mobile/mobile"),
    'file': require("../file/file"),
    'terms': require("../terms/terms"),
    'gdprtext': require("../gdprtext/gdprtext"),
    'testvehicleslots': require("../testvehicleslots/testvehicleslots"),
};

// the css is injected automatically
require('!style-loader!css-loader!postcss-loader!stylus-loader!./submit.styl');
var ajax = require("ajax");

// this helps us remove everything exepct whats inside the body node
var strip = require("striphtml");
var pagebreak = require("../pagebreak/pagebreak");
var Q = require('q');
var getData = require('../../scripts/getdata')(MBGF.mbfa_apibase);
var validation = require('validation')(getData).submit;

expose.parse = function (text, next) {
    strip(require('raw!./submit.html'), function(html) {
        if (text.indexOf("input") > -1 || text.indexOf("textarea" ) > -1 || text.indexOf("select") > -1 ) {
            text += html;
        }
        next(text);
    });
};

var form = null;

// this method can initialize the DOM object, add interacton etc. It is called after everything has been rendered
expose.init = function (formRoot, meta, next) {

    var html = formRoot.innerHTML;
    form = formRoot;

    var submit_button = formRoot.querySelector("#submit_button");

    if (submit_button) {
        submit_button.addEventListener("click", function (e) {
            e.preventDefault();
            expose.submit(formRoot);
            return false;
        }, false);
    }

    if (MBGF.enableRecaptcha) {
        var googleRecaptcha = formRoot.querySelector("#g-recaptcha");
        if (googleRecaptcha) {
            googleRecaptcha.setAttribute('data-sitekey', MBGF.recaptchaPublicKey);
            googleRecaptcha.setAttribute("data-required", "true");
            googleRecaptcha.setAttribute("class", googleRecaptcha.getAttribute("class") + " required");

            // Now that we've created the google captcha we may load the scripts.
            // The google captcha script expects the captcha module to exists once loaded
            var s = document.createElement("script");
            s.type = "text/javascript";
            s.src = "https://www.google.com/recaptcha/api.js";
            var h = document.getElementsByTagName('head')[0];
            h.appendChild(s);
        }
    } else {
        var recaptchaContainer = formRoot.querySelector("#mbgf-recaptcha-container");
        if (recaptchaContainer) {
            recaptchaContainer.remove();
        }
    }

    next(formRoot);

};


// Posts the data
expose.post = function (data, next) {

    try {

        var formData = new FormData();

        Object.keys(data).forEach(function(key) {
            if (key === 'file') {
                formData.append('file', data[key].files[0]);
            } else {
                formData.append(key, data[key]);
            }
        });

        var url = MBGF.ajaxurl + '&formid=' + MBGF.formid;

        fetch(url, { credentials: 'include', method: 'POST', body: formData })
            .then(function(result) {
                return result.json();
            })
            .then(function(json) {
                next(null, json);
            })
            .catch(function (err) {
                console.error(err);
                next(err);
            });

    } catch (err) {
        console.log('err', err);
        next(err);
    }


};

function submit_get(context){
    var recaptchaValue = context.querySelector('[name="g-recaptcha-response"]');
    return recaptchaValue ? recaptchaValue.value : '';
}

function submit_validate(context){

    var recaptchaInput = context.querySelector('#g-recaptcha');

    if (!MBGF.enableRecaptcha) { // Validate the submit module if there is no captcha
        return true;
    }

    var value = submit_get(context);

    var required = recaptchaInput.getAttribute("data-required") == "true";

    var messagelabel = context.querySelector("#recaptcha_error");
    messagelabel.innerHTML = "";

    var validationResult = validation.validate(value, required);
    if (!validationResult.valid) {

        var message = '';

        if( validationResult.errorType ) {
            message = document.createTextNode(recaptchaInput.getAttribute("data-msg-" + validationResult.errorType));
        }

        messagelabel.appendChild(message);
        messagelabel.setAttribute("class", " error");
    }

    return validationResult.valid;
}


function findEloquaGUID(){
    var deferred = Q.defer();
    if (typeof window.GetElqCustomerGUID === 'function' && GetElqCustomerGUID()){
        deferred.resolve(GetElqCustomerGUID());
    } else {
        var times = 0;
        var timeoutTimes = 6;

        var timeout = setInterval(function(){
            times++;
            if(typeof window.GetElqCustomerGUID === 'function' && GetElqCustomerGUID()){
                clearInterval(timeout);
                deferred.resolve(GetElqCustomerGUID());
            } else if(times >= timeoutTimes){
                clearInterval(timeout);
                deferred.resolve(-1);
            }
        }, 500);
    }
    return deferred.promise;
}

function collectGetParams () {
    var params = {};
    var elqCampaignId = parseInt(expose.getUrlParameter('elq_campaign_id'), 10);
    if (elqCampaignId && Number.isInteger(elqCampaignId)) {
        params['elqCampaignId'] = elqCampaignId;
    }
    return params;
}

expose.getUrlParameter = function (name) {
    var regex = new RegExp('[\\\?&]' + name + '=([^&#]*)','gi');
    var results = regex.exec(window.location.search);
    return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
};

expose.requireEloquaGUID = function(data, next){

    if (!MBGF.useEloqua){
        return next(data); // Dont bother looking for the GUID
    }
    Q.resolve()
        .then(function(){return findEloquaGUID()})
        .then(function(guid) {
            data.elqCustomerGUID = guid;
            if(guid === -1){ // Error
                data.elqCustomerError = "Could not fetch eloqua GUID"
            }
            return next(data);
        });

};

// Gathers everythign, validates and posts
expose.submit = function (context, next) {
    var loadingLayer = document.querySelector("#loadingLayer");
    var submit_button = context.querySelector("#submit_button");

    submit_button.disabled = true;
    expose.resetValidationState(context, function () {

        expose.validate(context, function (ok) {

            jQuery("#mbgf-form").trigger("mbgfFormDidCollectData", [ok]);
            if (ok) {
                expose.collect(context, function (data) {
                    var submitBox = context.querySelector(".submit-box");
                    var submitBoxOldClass = (submitBox) ? submitBox.getAttribute("class") : "";

                    if (submitBox) {
                        submitBox.setAttribute("class", submitBoxOldClass + " submitting");
                    }

                    if( loadingLayer ) {
                        var newClass = loadingLayer.getAttribute('class').replace(/(|\s)hidden(|\s)/g, "");
                        loadingLayer.setAttribute('class', newClass);
                    }

                    expose.requireEloquaGUID(data, function(data){

                        jQuery("#mbgf-form").trigger("mbgfFormWillPost",[data]);

                        expose.post(data, function (err, result) {
                            jQuery("#mbgf-form").trigger("mbgfFormDidPost",[result, err, data]);
                            if( loadingLayer ) {
                                var newClass = loadingLayer.getAttribute('class').replace(/(|\s)hidden(|\s)/g, "") + ' hidden';
                                loadingLayer.setAttribute('class', newClass);
                            }
                            submit_button.disabled = false;

                            // Reset the captcha
                            if (window.grecaptcha) {
                                grecaptcha.reset();
                            }

                            if( result.success == false && !err ) {
                                err = result;
                            }

                            if( err ) {

                                if(err.error == 'not-valid' && err.errors ) {
                                    // validation error in backend, insert errors into modules
                                    var modules = expose.getModules(context);

                                    for (var i = 0; i < err.errors.length; i++) {
                                        var error = err.errors[i];

                                        if( error.key == 'retailers' && !modules.hash[error.key] ) {
                                            error.key = 'retailersmodal';
                                        }

                                        if( error.hasModule == true && modules.hash[error.key] && modules.hash[error.key].module.validate ) {
                                            modules.hash[error.key].module.validate(modules.hash[error.key].context, error);
                                        }
                                    }
                                } else if (err.trackandtrace) {

                                    // These are special error messages for track and trace
                                    // They open up modals defined in footer.php. The modals should really just be rendred
                                    // if its a track and trace form, but currently we render them anyway
                                    
                                    if( typeof jQuery == 'function' ) {
                                        if (err.trackandtrace.name === 'commission-number-already-registered') {
                                            jQuery('#error-modal-trackandtrace').modal('show');
                                        } else if (err.trackandtrace.name === 'commission-number-not-found') {
                                            jQuery('#error-modal-trackandtrace-no-commission').modal('show');
                                        }
                                    }

                                } else {
                                    //console.log('unhandled error', err);
                                    if( typeof jQuery == 'function' ) {
                                        jQuery('#error-modal').modal('show');
                                    }
                                }
                            }
                            else {
                                if (result && result.success === true) {

                                    if (result.flowstack && result.flowstack.redirect) {
                                        window.location.href = result.flowstack.redirect;
                                        return;
                                    }

                                    if (window && window.afterFormSubmitSuccess && typeof window.afterFormSubmitSuccess === 'function') {
                                        window.afterFormSubmitSuccess(data);
                                    }

                                    if(typeof go_to_section == 'function') {
                                        insertSubmittedData(document.getElementById('section-thank-you'), data);
                                        var thankYouSection = document.querySelector('#section-thank-you');
                                        if( thankYouSection ) {
                                            go_to_section('#section-thank-you');
                                        }
                                    }
                                    else if (pagebreak.hasThankYouPage) {
                                        var currentpage = context.querySelector(".currentpage");
                                        currentpage.className = currentpage.className.replace("currentpage", "");

                                        var errorpage = document.getElementById("thank-you");
                                        errorpage.className = errorpage.className + " currentpage";
                                    }
                                    else {
                                        if (submitBox) {
                                            submitBox.setAttribute("class", submitBoxOldClass);
                                        }
                                    }
                                    expose.clearFormState(context);
                                }
                                else if (result && result.success === false) {

                                    if (pagebreak.hasErrorPage) {

                                        var currentpage = context.querySelector(".currentpage");
                                        currentpage.className = currentpage.className.replace("currentpage", "");

                                        var errorpage = document.getElementById("error");
                                        errorpage.className = errorpage.className + " currentpage";
                                    }
                                    else {
                                        if (submitBox) {
                                            submitBox.setAttribute("class", submitBoxOldClass);
                                        }
                                    }
                                }
                            }

                            if (next && typeof next == "function") {
                                next(data);
                            }
                        });
                    });
                });
            }
            else {
                submit_button.disabled = false;
                if (next && typeof next == "function") {
                    next(false);
                }
            }
        });
    });
};

// resets the validationstate of the form
expose.resetValidationState = function (context, next) {
    var html = context.innerHTML;

    // get all modules
    var modules = expose.getModules(context);
    // console.log("modules: ", modules);

    for (var i = 0, ii = modules.contexts.length; i < ii; i++) {
        var module = modules.contexts[i].module;
        var moduleFullName = modules.list[i];
        var moduleInfo = modules.contexts[i];//modules[moduleFullName];
        //console.log("module.resetValidationState: ", module.resetValidationState);
        if (module.resetValidationState && typeof module.resetValidationState == "function") {
            module.resetValidationState(moduleInfo.context);
        }
    }

    if (next && typeof next == "function") {
        next();
    }
}

// Validates the form after running trough all validators
expose.validate = function (context, next) {

    var html = context.innerHTML;

    // get all modules
    var modules = expose.getModules(context);

    var ok = true;
    var completedValidations = [];

    completedValidations.push(submit_validate(context));

    for(var i = 0, ii = modules.contexts.length; i < ii; i++) {
        var module = modules.contexts[i].module;
        var moduleFullName = modules.list[i];
        var moduleInfo = modules.contexts[i];//modules[moduleFullName];

        if (module.validate && typeof module.validate == "function") {
            completedValidations.push(module.validate(moduleInfo.context, null, moduleInfo.formRoot));
        }
    }

    Q.resolve()
        .then(function() {
            return Q.allSettled(completedValidations);
        })

        .then(function(completedValidations) {
            var ok = true;


            for(var i = 0, ii = completedValidations.length; i < ii; i++) {
                // console.log('c', completedValidations[i]);
                ok = ok && completedValidations[i].value;
            }

            return ok;
        })
        .then(function(ok) {
            next(ok);
        });
}

expose.collect = function (context, next) {

    var html = context.innerHTML;

    // get all modules
    var modules = expose.getModules(context);
    var pluginData = {
        embedUrl: window.location.href + window.location.hash + window.location.search,
        referrerUrl: MBGF.referrerUrl,
        pluginVersion: MBGF.pluginVersion
    };
    var queryVariables = collectGetParams();
    var data = Object.assign({}, pluginData, queryVariables);
    if (MBGF.enableRecaptcha) { // data will be our post obejct so lets append the captcha respond we need to verify
        data['g-recaptcha-response'] = submit_get(context);
    }

    // If we find a referer query string, lets post it as well
    if (window.location.search) {
        var query = window.location.search.replace(/^\?/, '').split('&');
        for ( var i = 0, ii = query.length; i < ii; i++) { 
            var pairs = query[i].split('=');
            if (pairs[0] === 'referer') {
                data.referer = pairs[1];
            }
        }
    }

    // gather all infor on each module from the correct context
    for (var i = 0, ii = modules.contexts.length; i < ii; i++) {

        var module = modules.contexts[i].module;
        var moduleFullName = modules.list[i];
        var moduleInfo = modules.contexts[i];

        if (module.get && typeof module.get == "function") {

            var dataKey = (module.getDataKey && typeof module.getDataKey == "function") ? moduleInfo.name + "." + module.getDataKey(moduleInfo.context) : moduleInfo.name;

            if( module.dataKey && typeof module.dataKey == 'string' ) {
                dataKey = module.dataKey;
            }


            if (typeof module.skipCollect == "undefined" || module.skipCollect  === false) {
                var value = module.get(moduleInfo.context);
                if (value || value === '') {
                    data[dataKey] = value;
                }
            }

            // This gives us a chance to chnage the data i needed. 
            // We created it because the consenthpone module has chnaged to an inverted version,
            // meaning that a checked box is denypost, and all our checkboxes behave in the opposite way
            if (module.transform && typeof module.transform === 'function') {
                data = module.transform(dataKey, data);
            }


        }

    }

    // This is a special case that handles the ucid. It doesnt require a markdown object
    if (context.querySelector('#ucid') != null) {
        var ucid = context.querySelector('#ucid').value;
        data['ucid'] = ucid;
    }

    if (next && typeof next == "function") {
        next(data);
    }

}

expose.clearFormState = function(context) {
    var html = context.innerHTML;

    // get all modules
    var modules = expose.getModules(context);

    // gather all infor on each module from the correct context
    for (var i = 0, ii = modules.contexts.length; i < ii; i++) {
        var module = modules.contexts[i].module;
        var moduleFullName = modules.list[i];
        var moduleInfo = modules.contexts[i];

        if (module.reset && typeof module.reset == "function") {
            module.reset(moduleInfo.context);
        }
    }
}

expose.getModules = function (context) {
    var html = context.innerHTML;
    var moduleDomList = context.querySelectorAll("*[data-module]");

    var result = {
        list: [],
        contexts: [],
        hash: {},
    };

    // Fins all modules by analysing the context and gettting them with the data-module attribute
    for (var i = 0, ii = moduleDomList.length; i < ii; i++) {
        var moduleDom = moduleDomList[i];
        var moduleName = moduleDom.getAttribute("data-module");
        var moduleFullName = "../" + moduleName + "/" + moduleName;
        var suffix = "";
        suffixNumber = 1;
        while (typeof result[moduleFullName + suffix] != "undefined") {
            suffix = "-" + suffixNumber;
            suffixNumber++;
        }

        result.list.push(moduleFullName);

        result.contexts.push({
            name: moduleName,
            context: moduleDom,
            formRoot: context,
            module: mdModules[moduleName],
        });

        result.hash[moduleName] = {
            name: moduleName,
            context: moduleDom,
            module: mdModules[moduleName],
        };
        /*result[moduleFullName + suffix] = {
            name: moduleName,
            context: moduleDom
        };*/
    }
    return result;

}

function insertSubmittedData(el, data) {
    var modelData = mdModules.models.data(data.models);
    var modelImage = (modelData && modelData.image && modelData.image.url) ? modelData.image.url : '';

    var retailerData = mdModules.retailers.data(data.retailers);

    if( !retailerData ) {
        retailerData = mdModules.retailersmodal.data(data.retailers);
    }

    var retailerLabel = (retailerData.label) ? retailerData.label : retailerData.city + ': ' + retailerData.name;
    var retailerValue = (retailerData.value) ? retailerData.value : retailerData.outletcodeMb;

    if( el ) {
        var newHTML = el.innerHTML
            .replace(/{{firstname.value}}/g, data.firstname || '')
            .replace(/{{mobile.value}}/g, data.mobile || '')
            .replace(/{{phone.value}}/g, data.phone || '')
            .replace(/{{lastname.value}}/g, data.lastname || '')
            .replace(/{{model.label}}/g, modelData.label || '')
            .replace(/{{model.value}}/g, modelData.value || '')
            .replace(/{{model.brochure}}/g, modelData.model_brochure || '')
            .replace(/{{model.modelbrochure}}/g, modelData.model_brochure || '')
            .replace(/{{model.image}}/g, modelImage)
            .replace(/{{model.configuratorlink}}/g, modelData.configuratorlink || '')
            .replace(/{{email.value}}/g, data.email || '')
            .replace(/{{retailer.label}}/g, retailerLabel || '')
            .replace(/{{retailer.value}}/g, retailerValue || '');

        el.innerHTML = newHTML;
    }

    return el;
}

module.exports = expose;



// WEBPACK FOOTER //
// ./js-src/markdown-editor/modules/submit/submit.js